import React, {Component} from 'react';
import logo from '../../logomercenaries.png';
import './App.css';
import ActionButton from "../ActionButton/ActionButton";
import DebugContainer from "../DebugContainer/DebugContainer";


class App extends Component {
    constructor(props) {
        super(props);
        this.updateDebugMessage = this.updateDebugMessage.bind(this);
        this.handleBeforeInstallPrompt = this.handleBeforeInstallPrompt.bind(this);
        this.state = {
            debugMessages: Array()
        };

        window.addEventListener('beforeinstallprompt', this.handleBeforeInstallPrompt);
    }

    handleBeforeInstallPrompt(e) {
        this.updateDebugMessage('beforeinstallprompt was fired');
    }

    updateDebugMessage(message) {
        console.log('updating error message: ' + message);

        let ts = this.state.debugMessages.slice();
        ts.push(message);
        this.setState({debugMessages: ts})
    }

    render() {
        return (
            <div className="App">
                <img src={logo} className="App-logo" alt="logo"/>
                <ActionButton
                    label={"Play now!"}
                    action={this.updateDebugMessage}
                />
                <DebugContainer message={this.state.debugMessages}/>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.js